import type { ResourceIdentifierWithType } from '../content';

type ResourceTreeNode<T> = {
  contentIdentifier: string;
  digitalResourceType: ResourceIdentifierWithType['digitalResourceType'];
  children?: Array<T>;
};

export type FlattenedResource<T> = T & {
  parentIdentifier?: string;
  parents: Array<ResourceIdentifierWithType>;
};

export function flattenResources<T extends ResourceTreeNode<T>>(
  resources: Array<T>,
  parents: Array<ResourceIdentifierWithType> = [],
): Array<FlattenedResource<T>> {
  return resources.flatMap((resource) => {
    const parent = parents.at(-1);
    const children = resource.children ?? [];
    const copy = {
      ...resource,
      parents,
      ...(parent ? { parentIdentifier: parent.contentIdentifier } : {}),
    } as FlattenedResource<T>;

    return [
      copy,
      ...flattenResources(children, [
        ...parents,
        {
          contentIdentifier: resource.contentIdentifier,
          digitalResourceType: resource.digitalResourceType,
        },
      ]),
    ];
  });
}
